import React from "react";
import { Card, Row, Col, Icon } from "antd";
import { useSelector } from "react-redux";
import useStockMovementContext from "../../../../hooks/useStockMovementContext";

const StockMovementSummaryCards = () => {
  const { translation } = useSelector((state) => state.app);
  const t = translation?.stockItem?.movements?.summary || {};
  const { data } = useStockMovementContext();

  const movements = Array.isArray(data) ? data : [];

  const entries = movements
    .filter((m) => m.status === "COMPLETED")
    .filter((m) => m.type === "ENTRY").length;
  const exits = movements
    .filter((m) => m.status === "COMPLETED")
    .filter((m) => m.type === "EXIT").length;
  // const pending = movements.filter((m) => m.status === "PENDING").length;

  const cards = [
    {
      label: t.entries || "Entradas",
      value: entries,
      icon: "download",
      color: "#52c41a",
    },
    {
      label: t.exits || "Saídas",
      value: exits,
      icon: "upload",
      color: "#f5222d",
    },
    // {
    //   label: t.pending || "Pendentes",
    //   value: pending,
    //   icon: "clock-circle",
    //   color: "#faad14",
    // },
  ];

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      {cards.map((card) => (
        <Col key={card.label} span={8}>
          <Card size="small" bordered>
            <Row type="flex" align="middle" justify="space-between">
              <Col>
                <div style={{ fontSize: 12, color: "#888" }}>{card.label}</div>
                <div style={{ fontSize: 24, fontWeight: 600 }}>
                  {card.value}
                </div>
              </Col>
              <Col>
                <Icon
                  type={card.icon}
                  style={{ fontSize: 28, color: card.color }}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StockMovementSummaryCards;
